import {Action} from '@ngrx/store';
import {BijbAccount} from '../../../models/bijb-account';

export class UpdateBijbAccountAction implements Action {
  public static readonly type = 'UpdateBijbAccountAction';

  constructor(public bijbAccount: BijbAccount) {
  }

  public type = UpdateBijbAccountAction.type;
}
